import { List } from 'immutable';
import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseEntity, BaseInlineContainer, DefaultButtonsConfig, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { EOtpremnicaPrevozInlineUpdateComponent } from './eotpremnica-prevoz-inline-update.component';

//import { PARAMETERS } from '@angular/core/src/util/decorators';

@Component({
  selector: 'yt-eotpremnica-prevoz-update-container',
  templateUrl: './eotpremnica-prevoz-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class EOtpremnicaPrevozUpdateContainer<T extends BaseEntity>
  extends BaseInlineContainer<T> {
  izlazna: boolean = false;

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService,
  ) {
    super(inlineContainerService, activatedRoute, userService);
  }
  @Input() Level: 'document' | 'item' | 'attribute' = 'document';
  // @Input() sopstveniPrevoz: boolean;
  // @Input() firmaData: any;
  
@ViewChild("baseDetailList", { static: false }) baseDetailList: any;

  tempItems: List<T>

  ngAfterViewInit() {


    if (this.baseDetailList.tableConfig) {
      this.izlazna = this.modelData.MainList.FormControlDataName == "eotpremnice/izeotpremnica";

      this.baseDetailList.tableConfig.ShowCheckBoxes = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.AddButtonConfig.Visible = this.izlazna;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.DeleteAllButtonConfig.Visible = false;
      this.baseDetailList.tableConfig.DefaultListButtonsConfig.PrintButtonConfig.Visible = false;
      this.baseDetailList.tableConfig.DeleteIcon.Visible = this.izlazna;
    }
  }
  // setItems(items) {
  //    this.tempItems = items;
  //   }


}


